import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon", "item"]

  toggle() {
    // If we have item targets, toggle between them (show/hide alternating)
    if (this.hasItemTarget) {
      this.itemTargets.forEach(item => item.classList.toggle("hidden"))
      return
    }

    // Legacy behavior: toggle single content target
    if (this.hasContentTarget) {
      this.contentTarget.classList.toggle("hidden")

      if (this.hasIconTarget) {
        this.iconTarget.textContent = this.contentTarget.classList.contains("hidden") ? "▼" : "▲"
      }
    }
  }
}
